const DESKTOP_HEADER_HEIGHT = 77.6
const MOBILE_HEADER_HEIGHT = 49.6

const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'MD', 'MA', 'ME', 'MI', 'MS', 'MO', 'MT', 'NE', 'NH', 'NV', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'US', 'VI', 'UT', 'VA', 'WA', 'WV', 'WY']

const constant = {DESKTOP_HEADER_HEIGHT, MOBILE_HEADER_HEIGHT, states}

export default constant